module.exports = {"dashboard":"ダッシュボード","search":"探す","calendar":"カレンダー","mailbox":"メールボックス","widgets":"ウィジェット","social":"ソーシャル","charts":"チャート","media":"メディア","overlays":"オーバーレイ","snackbar":"スナックバー","authorization":"認可","login":"ログインする","users":"ユーザー"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja.json
// module id = 1ccB
// module chunks = 1